import { ClientFetchService } from "@lib/helpers/clientFetchService";
import { generateRecaptchaToken } from "./recaptcha/generateRecaptchaToken";

type ValidateRecaptchaParams = {
    /**
     * @returns A promise that resolves when the reCAPTCHA challenge is successful.
     */
    onSuccess?: () => void | Promise<void>;
    /**
     * @returns A promise that resolves when the reCAPTCHA challenge fails.
     */
    onAbort?: () => void | Promise<void>;
    /**
     *
     * @param e Error that occurred during the reCAPTCHA validation.
     * @returns A promise that resolves when an error occurs during the challenge.
     */
    onError?: (e: Error) => void | Promise<void>;
    action: string;
    shouldCheck?: boolean;
};

export const validateRecaptcha = async ({
    onSuccess,
    onAbort,
    onError,
    action,
    shouldCheck = true,
}: ValidateRecaptchaParams): Promise<void> => {
    if (!shouldCheck) {
        try {
            await onSuccess?.();
        } catch (e) {
            await onError?.(e as Error);
        }
        return;
    }

    try {
        const token = await generateRecaptchaToken(action);

        await ClientFetchService.post(`/api/validate-recaptcha`, {
            recaptchaToken: token,
        });

        await onSuccess?.();
    } catch (error: any) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        error?.response?.status === 403 ? await onAbort?.() : await onError?.(error as Error);
    }
};
